import React from "react";
import "./SectionContainer.scss";

const SectionContainer = ({ children }) => {
  return <section className="section-container">{children}</section>;
};

export default SectionContainer;
